export default "/images/controller.png?6e6f4e9c1eedd5b56e67c5b9465f3608";